import { j as e } from "./atoms-v218.js";
import { forwardRef as C, useState as m } from "react";
import { ToggleSkeleton as E } from "./atoms-v2748.js";
import { Toggle as H, Input as I, Label as L, LabelText as p, Switch as N, Handle as q } from "./atoms-v2749.js";
const z = C(
  ({
    ariaHidden: T = !1,
    ariaLabel: a,
    className: R,
    colorTheme: i = "light",
    defaultChecked: r = !1,
    disabled: t = !1,
    display: c = "inline",
    id: h,
    isSkeleton: k = !1,
    label: d,
    labelPosition: n = "left",
    name: $,
    onBlur: g,
    onChange: f,
    onFocus: u,
    readOnly: l = !1,
    size: o = "default",
    ...F
  }, D) => {
    const [x, S] = m(r), [w, j] = m(!1), b = (s) => {
      S(s.target.checked), f && f(s);
    }, y = (s) => {
      j(!1), g && g(s);
    }, B = (s) => {
      j(!0), u && u(s);
    };
    return /* @__PURE__ */ e.jsxs(
      H,
      {
        $display: c,
        $size: o,
        "aria-hidden": T,
        "aria-label": a,
        className: R,
        id: h,
        children: [
          /* @__PURE__ */ e.jsx(
            I,
            {
              defaultChecked: r,
              disabled: t || l,
              id: h || $,
              name: $,
              onBlur: y,
              onChange: b,
              onFocus: B,
              readOnly: l,
              ref: D,
              type: "checkbox",
              ...F
            }
          ),
          k ? /* @__PURE__ */ e.jsx(
            E,
            {
              ariaLabel: a,
              defaultChecked: r,
              display: c,
              labelPosition: n,
              size: o
            }
          ) : /* @__PURE__ */ e.jsxs(L, { $display: c, $isDisabled: t, $isReadOnly: l, htmlFor: h || $, children: [
            n === "left" ? /* @__PURE__ */ e.jsx(p, { $colorTheme: i, children: d }) : null,
            /* @__PURE__ */ e.jsx(
              N,
              {
                "aria-hidden": !0,
                $colorTheme: i,
                $isChecked: x,
                $isDisabled: t,
                $isFocused: w,
                $isReadOnly: l,
                $size: o,
                children: /* @__PURE__ */ e.jsx(
                  q,
                  {
                    $colorTheme: i,
                    $isChecked: x,
                    $isDisabled: t,
                    $isReadOnly: l,
                    $size: o
                  }
                )
              }
            ),
            n === "right" ? /* @__PURE__ */ e.jsx(p, { $isRightPosition: !0, children: d }) : null
          ] })
        ]
      }
    );
  }
);
z.displayName = "Toggle";
export {
  z as Toggle
};
